import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { Button } from "@/components/ui/button";
import { AlertCircle, Watch, Heart, Smartphone } from "lucide-react";

interface SamsungHRSetupGuideProps {
  open: boolean;
  onClose: () => void;
  onUseHealthKit?: () => void;
  hasHealthKit?: boolean;
}

export const SamsungHRSetupGuide = ({ 
  open, 
  onClose, 
  onUseHealthKit,
  hasHealthKit = false 
}: SamsungHRSetupGuideProps) => {
  return (
    <AlertDialog open={open}>
      <AlertDialogContent className="max-w-[90%] sm:max-w-md">
        <AlertDialogHeader>
          <div className="flex items-center justify-center w-12 h-12 mx-auto mb-4 rounded-full bg-destructive/10">
            <AlertCircle className="w-6 h-6 text-destructive" />
          </div>
          <AlertDialogTitle className="text-center">
            Monitor Samsung Detectado
          </AlertDialogTitle>
          <AlertDialogDescription className="space-y-4 text-left">
            <p className="text-center">
              Para conectar seu Samsung Gear/Watch, siga os passos:
            </p>
            
            <div className="space-y-3">
              <div className="flex items-start gap-3 p-3 rounded-lg bg-muted/50">
                <div className="flex items-center justify-center w-8 h-8 rounded-full bg-primary/10 shrink-0">
                  <span className="text-sm font-semibold text-primary">1</span>
                </div>
                <div className="flex-1 pt-1">
                  <div className="flex items-center gap-2 mb-1">
                    <Watch className="w-4 h-4" />
                    <p className="font-medium">No relógio</p>
                  </div>
                  <p className="text-sm text-muted-foreground">
                    Abra o app <strong>Samsung Health</strong>
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-3 p-3 rounded-lg bg-muted/50">
                <div className="flex items-center justify-center w-8 h-8 rounded-full bg-primary/10 shrink-0">
                  <span className="text-sm font-semibold text-primary">2</span>
                </div>
                <div className="flex-1 pt-1">
                  <div className="flex items-center gap-2 mb-1">
                    <Heart className="w-4 h-4" />
                    <p className="font-medium">Inicie medição</p>
                  </div>
                  <p className="text-sm text-muted-foreground">
                    Toque em "Frequência Cardíaca" e inicie a medição
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-3 p-3 rounded-lg bg-muted/50">
                <div className="flex items-center justify-center w-8 h-8 rounded-full bg-primary/10 shrink-0">
                  <span className="text-sm font-semibold text-primary">3</span>
                </div>
                <div className="flex-1 pt-1">
                  <div className="flex items-center gap-2 mb-1">
                    <Smartphone className="w-4 h-4" />
                    <p className="font-medium">No app</p>
                  </div>
                  <p className="text-sm text-muted-foreground">
                    Volte aqui e toque em "Conectar Monitor" novamente
                  </p>
                </div>
              </div>
            </div>

            {hasHealthKit && (
              <div className="p-3 border rounded-lg bg-primary/5 border-primary/20">
                <p className="mb-2 text-sm font-medium">💡 Alternativa Recomendada</p>
                <p className="text-xs text-muted-foreground">
                  Se o Samsung Health sincroniza com Apple Health, você pode usar essa fonte de dados que é mais confiável.
                </p>
              </div>
            )}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter className="flex-col gap-2 sm:flex-col">
          {hasHealthKit && (
            <Button
              onClick={onUseHealthKit}
              className="w-full"
            >
              Usar Apple Health
            </Button>
          )}
          <Button
            variant="outline"
            onClick={onClose}
            className="w-full"
          >
            Entendi, Tentar Novamente
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
